/**
 * Copy de cara al cliente del newsletter (B9 fase web), en UN único archivo para
 * permitir tests verbatim (spec docs/specs/newsletter-web-plan.md §4). Si alguien
 * edita un texto, `newsletter.copy.spec.ts` lo delata.
 *
 * `SUCCESS` es EXACTAMENTE `NewsletterCopy::CHECK_INBOX` de la API: la API responde
 * 202 con ese texto en todos los casos de éxito, y la web lo pinta desde aquí.
 */

const CONSENT_BEFORE =
  'Al suscribirte aceptas recibir novedades y ofertas de Perrón Store por correo. Puedes darte de baja cuando quieras. Más información en nuestra ';
const CONSENT_LINK = 'Política de Privacidad';
const CONSENT_AFTER = '.';

export const NEWSLETTER_COPY = {
  SUCCESS:
    'Revisa tu correo: si tu suscripción necesita confirmarse, te llegará un enlace en unos minutos.',
  INVALID_EMAIL: 'Ese correo no parece válido.',
  RATE_LIMITED: 'Espera un momento antes de volver a intentarlo.',
  GENERIC_ERROR: 'No pudimos registrar tu suscripción. Intenta más tarde.',
  /** Nombre accesible del campo (no tiene `<label>` visible; el placeholder no cuenta). */
  EMAIL_LABEL: 'Correo electrónico',

  /** Microcopy de consentimiento (B8, §8.2 del spec de la API). No nombra a Brevo. */
  CONSENT: CONSENT_BEFORE + CONSENT_LINK + CONSENT_AFTER,
  CONSENT_BEFORE,
  CONSENT_LINK,
  CONSENT_AFTER,
  CONSENT_HREF: '/privacidad',

  /** `/newsletter/confirmada`, destino de `BREVO_DOI_REDIRECT_URL`. */
  CONFIRMED_TITLE: '¡Listo! Tu suscripción está confirmada.',
  CONFIRMED_BODY: 'Te avisaremos de preventas, lanzamientos, torneos y ofertas. Nos vemos en la tienda.',
  CONFIRMED_CTA: 'Ir a la tienda',
  CONFIRMED_CTA_HREF: '/tienda',

  POPUP_TITLE: '¿Te avisamos de lo nuevo?',
  POPUP_BODY: 'Preventas, lanzamientos y torneos, un par de veces al mes. Sin spam.',
  POPUP_DISMISS: 'Ahora no',
  /** Solo para lector de pantalla (botón de cierre con icono). */
  POPUP_CLOSE_LABEL: 'Cerrar',
} as const;
